export const resetters: (() => void)[] = []

export const resetStore = () => {
  resetters.forEach((resetter) => resetter())
}
